import { SET_NOTIFICATION, SET_NOTIFICATIONS } from "../../constants/notificationConstants";

export const setNotification = (notification) => {
  return {
    type: SET_NOTIFICATION,
    notification,
  };
};

export const setNotifications = (notifications, filtered = false) => {
  return {
    type: SET_NOTIFICATIONS,
    notifications,
    filtered,
  };
};
